//common functionalities for all the javascript featueres
export var Frontend = {}; // common variable used in all the files of the frontend
(function () {

    Frontend = {

        // SweetAlert2 options for confirm dialogs: app buttons (styled in custom.scss), Cancel first and focused,
        // the action red when it destroys something
        confirmDialog: function (danger) {
            return {
                buttonsStyling: false,
                reverseButtons: true,
                focusCancel: true,
                customClass: {
                    popup: 'xob-confirm',
                    confirmButton: 'btn ' + (danger ? 'btn-danger' : 'btn-primary'),
                    cancelButton: 'btn btn-outline-secondary',
                },
            };
        },

        Utils: {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            toggleClass: function (element, className) {
                if (element.classList) {
                    element.classList.toggle(className);
                } else {
                    var classes = element.className.split(' ');
                    var existingIndex = classes.indexOf(className);

                    if (existingIndex >= 0)
                        classes.splice(existingIndex, 1);
                    else
                        classes.push(className);

                    element.className = classes.join(' ');
                }
            },
            addClass: function (element, className) {
                if (element.classList)
                    element.classList.add(className);
                else
                    element.className += ' ' + className;
            },
            removeClass: function (el, className) {
                if (el.classList)
                    el.classList.remove(className);
                else
                    el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            },

            documentReady: function (callback) {
                if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
                    callback();
                } else {
                    document.addEventListener('DOMContentLoaded', callback);
                }
            },

            ajaxrequest: function (url, method, data, csrf, callback) {
                var request = new XMLHttpRequest();
                var loadingIcon = jQuery(".loading");
                if (window.XMLHttpRequest) {
                    // code for modern browsers
                    request = new XMLHttpRequest();
                } else {
                    // code for old IE browsers
                    request = new ActiveXObject("Microsoft.XMLHTTP");
                }
                request.open(method, url, true);

                request.onloadstart = function () {
                    loadingIcon.show();
                };
                request.onloadend = function () {
                    loadingIcon.hide();
                };
                request.setRequestHeader('X-CSRF-TOKEN', csrf);
                request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                if ("post" === method.toLowerCase() || "patch" === method.toLowerCase()) {
                    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                    data = this.jsontoformdata(data);
                }

                // when request is in the ready state change the details or perform success function
                request.onreadystatechange = function () {
                    if (request.readyState === this.DONE) {
                        // Everything is good, the response was received.
                        request.onload = callback.success(request);
                    }
                };
                request.onerror = callback.error;
                request.send(data);
            },

            // This should probably only be used if all JSON elements are strings
            jsontoformdata: function (srcjson) {
                if (typeof srcjson !== "object")
                    if (typeof console !== "undefined") {
                        return null;
                    }
                let u = encodeURIComponent;
                var urljson = "";
                var keys = Object.keys(srcjson);
                for (var i = 0; i < keys.length; i++) {
                    urljson += u(keys[i]) + "=" + u(srcjson[keys[i]]);
                    if (i < (keys.length - 1)) urljson += "&";
                }
                return urljson;
            },


            setCSRF: function () {
                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': this.csrf
                    }
                });
            },
            dtAnchorToForm: function ($parent) {

                $('td:last', $parent).addClass('btn-td');
                $('[data-method]', $parent).append(function () {
                    if (!$(this).find('form').length > 0) {
                        var method = this.getAttribute('data-method');

                        if (method == 'delete') {
                            return "\n<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
                                "<input type='hidden' name='_method' value='" + $(this).attr('data-method') + "'>\n" +
                                "<input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                                '</form>\n';
                        } else {
                            return "\n<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
                                "<input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                                '</form>\n';
                        }
                    } else {
                        return ''
                    }
                })
                    .attr('href', '#')
                    .attr('style', 'cursor:pointer;')
                    .attr('onclick', '$(this).find("form").submit();');
                $('form').submit(function () {
                    $(this).find('input[type="submit"]').attr('disabled', true);
                    $(this).find('button[type="submit"]').attr('disabled', true);
                    return true;
                });

                /**
                 * Generic confirm form delete using Sweet Alert
                 */


            },

        },
        DataTable: {
            init: function (datatable, onCreatedSuccessfully = null) {
                // Row "more actions" menus: the table sits in an overflow container that would clip the menu,
                // so it is moved to <body> while open (Bootstrap keeps positioning it from the toggle)
                $(document).off('.rowMenu')
                    .on('show.bs.dropdown.rowMenu', '.row-menu', function () {
                        const $menu = $(this).find('.row-menu__items');
                        const name = $(this).closest('tr').find('td').first().text().trim();
                        $(this).data('rowMenu', $menu);
                        $menu.attr('data-row-name', name).appendTo('body');
                    })
                    .on('hidden.bs.dropdown.rowMenu', '.row-menu', function () {
                        const $menu = $(this).data('rowMenu');
                        $menu && $menu.appendTo(this);
                    });

                // Page-size select: resize the table this page initialised (was hardcoded to #vendors-table)
                $('#count').change(function () {
                    datatable.page.len($('#count').val()).draw();
                });

                $('body').on('submit', 'form[name=delete_item]', function (e) {
                    e.preventDefault();

                    const form = this;
                    const link = $('a[data-method="delete"]');
                    const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Cancel';
                    const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Yes, delete';

                    // Name the item when the row has one (first column), so it is clear what gets deleted
                    const name = ($(form).closest('tr').find('td').first().text()
                        || $(form).closest('[data-row-name]').attr('data-row-name') || '').trim();

                    Swal.fire({
                        ...Frontend.confirmDialog(true),
                        title: 'Delete this item?',
                        text: name ? `"${name}" will be permanently deleted.` : "This can't be undone.",
                        showCancelButton: true,
                        confirmButtonText: confirm,
                        cancelButtonText: cancel,
                        icon: 'warning'
                    }).then((result) => {
                        result.value && $(form).ajaxSubmit({
                            success: function (data) {
                                XonBoard.Utils.handleSuccess(data.flash_success)

                                datatable.ajax.reload();
                            },
                            error: function (xhr, status, data) {
                                XonBoard.Utils.handleError(xhr, data)
                            }
                        });
                    });
                }).on('click', 'a[name=confirm_item]', function (e) {
                    /**
                     * Generic 'are you sure' confirm box
                     */
                    e.preventDefault();

                    const link = $(this);
                    const title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : 'Are you sure you want to do this?';
                    const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Cancel';
                    const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Continue';

                    Swal.fire({
                        ...Frontend.confirmDialog(false),
                        title: title,
                        showCancelButton: true,
                        confirmButtonText: confirm,
                        cancelButtonText: cancel,
                        icon: 'info'
                    }).then((result) => {
                        result.value && window.location.assign(link.attr('href'));
                    });
                });
                var currentMonth = new Date().getMonth();
                var currentYear = new Date().getFullYear();
                var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                $('#dateView').val(`${months[currentMonth]} ${currentYear}`);
                $('#decreaseSelectedMonth').click(function () {
                    if (currentMonth > 0) {
                        currentMonth--;
                    } else {
                        currentMonth = 11;
                        currentYear--;
                    }
                    $('#dateView').val(`${months[currentMonth]} ${currentYear}`);

                });
                $('#increaseSelectedMonth').click(function () {
                    if (currentMonth < 11) {
                        currentMonth++;
                    } else {
                        currentMonth = 0;
                        currentYear++;
                    }
                    $('#dateView').val(`${months[currentMonth]} ${currentYear}`);
                });

                $('#cancel').click(function () {
                    $('#create-modal').modal('hide');
                });

                $("#create-form").submit(function (e) {
                    e.preventDefault();
                    $("#create-form").ajaxSubmit({
                        resetForm: true,
                        success: function (data) {
                            $('.xob-modal').modal('hide');

                            XonBoard.Utils.handleSuccess(data.flash_success)

                            datatable.ajax.reload();
                            $(".submit-button").prop("disabled", false);

                            if(onCreatedSuccessfully) {
                                onCreatedSuccessfully(data);
                            }
                        },
                        error: function (xhr, status, data) {
                            XonBoard.Utils.handleError(xhr, data)

                            $(".submit-button").prop("disabled", false);
                        }
                    });
                });

            },
        },
        DataTableSearch: { //functionalities related to datable search at all the places
            selector: {},

            init: function (dataTable) {
                this.watchGlobalFilters(dataTable);
                this.watchPageLength(dataTable);
                this.setSelectors();
                this.setSelectors.divAlerts.delay(2000).fadeOut(800);
                this.addHandlers(dataTable);
            },
            watchGlobalFilters(dataTable) {
                $('.table-filter').on('change', function () {
                    dataTable.ajax.reload();
                });

                $('.table-global-filter').on('keyup', function (e) {
                    let code = e.key;

                    if (code === "Enter") {
                        e.preventDefault();
                        let value = $(this).val();

                        dataTable.search(value).draw();
                    }
                });
            },
            watchPageLength(dataTable) {
                $('.table-page-length').on('change', function (event) {
                    dataTable.page.len(event.target.value);
                    dataTable.ajax.reload();
                });
            },
            globalFilter: function (d) {
                let data = {};

                $('.table-filter').each(function () {
                    var value = $(this).val();
                    if (!!value) {
                        data[$(this).prop('name')] = value;
                    }
                });

                $.extend(d, data);
            },
            setSelectors: function () {
                this.selector.searchInput = document.querySelector("div.dataTables_filter input");
                this.selector.columnSearchInput = document.querySelectorAll(".search-input-text");
                this.selector.columnSelectInput = document.querySelectorAll(".search-input-select");
                this.selector.restButton = document.querySelectorAll('.reset-data');
                this.setSelectors.copyButton = document.getElementById("copyButton");
                this.setSelectors.csvButton = document.getElementById("csvButton");
                this.setSelectors.excelButton = document.getElementById("excelButton");
                this.setSelectors.pdfButton = document.getElementById("pdfButton");
                this.setSelectors.printButton = document.getElementById("printButton");
                this.setSelectors.divAlerts = jQuery('div.alert').not('.alert-important');
            },
            cloneElement: function (element, callback) {
                var clone = element.cloneNode();
                while (element.firstChild) {
                    clone.appendChild(element.lastChild);
                }
                element.parentNode.replaceChild(clone, element);
                Frontend.DataTableSearch.setSelectors();
                callback(this.selector.searchInput);
            },
            addHandlers: function (dataTable) {
                // get the datatable search input and on its key press check if we hit enter then search with datatable
                if(this.selector.searchInput) {
                    this.cloneElement(this.selector.searchInput, function (element) { //cloning done to remove any binding of the events
                        element.onkeypress = function (event) {
                            if (event.keyCode == 13) {
                                dataTable.fnFilter(this.value);
                            }
                        };
                    }); // to remove all the listinerers
                }

                // for text boxes
                //column input search if search box on the column of the datatable given with enter then search with datatable
                if (this.selector.columnSearchInput.length > 0) {
                    this.selector.columnSearchInput.forEach(function (element) {
                        element.onkeypress = function (event) {
                            if (event.keyCode == 13) {
                                var i = element.getAttribute("data-column"); // getting column index
                                var v = element.value; // getting search input value
                                dataTable.columns(i).search(v).draw();
                            }
                        };
                    });
                }


                // Individual columns search
                if (this.selector.columnSelectInput.length > 0) {
                    this.selector.columnSelectInput.forEach(function (element) {
                        element.onchange = function (event) {
                            var i = element.getAttribute("data-column"); // getting column index
                            var v = element.value; // getting search input value
                            dataTable.columns(i).search(v).draw();
                        };
                    });
                }

                // Individual columns reset
                if (this.selector.restButton.length > 0) {
                    this.selector.restButton.forEach(function (element) {
                        element.onclick = function (event) {
                            var inputelement = this.previousElementSibling;
                            var i = inputelement.getAttribute("data-column");
                            inputelement.value = "";
                            dataTable.columns(i).search("").draw();
                        };
                    });
                }

                if (this.setSelectors.copyButton) {
                    this.setSelectors.copyButton.onclick = function (element) {
                        document.querySelector(".copyButton").click();
                    };
                }
                if (this.setSelectors.csvButton) {
                    this.setSelectors.csvButton.onclick = function (element) {
                        document.querySelector(".csvButton").click();
                    };
                }
                if (this.setSelectors.excelButton) {
                    this.setSelectors.excelButton.onclick = function (element) {
                        document.querySelector(".excelButton").click();
                    };
                }
                if (this.setSelectors.pdfButton) {
                    this.setSelectors.pdfButton.onclick = function (element) {
                        document.querySelector(".pdfButton").click();
                    };
                }
                if (this.setSelectors.printButton) {
                    this.setSelectors.printButton.onclick = function (element) {
                        document.querySelector(".printButton").click();
                    };
                }
            }

        },

    };

    document.addEventListener('DOMContentLoaded', function () {
        let modalPressTarget = null;

        $(document).on('mousedown', '.xob-modal', function (e) {
            modalPressTarget = e.target;
        });

        $(document).on('click', '.xob-modal', function (e) {
            const pressedOutside = modalPressTarget && !$(modalPressTarget).closest('.modal-dialog').length;
            modalPressTarget = null;

            if (pressedOutside && !$(e.target).closest('.modal-dialog').length && $(this).data('backdrop') !== 'static') {
                $(this).modal('hide');
            }
        });

        $(document).on('hidden.bs.modal', '#edit-modal, #show-modal', function () {
            $(this).remove();
        });
    });
})();



